import { render, staticRenderFns } from "./ZgbTeamMembersList.vue?vue&type=template&id=14bb64f4"
import script from "./ZgbTeamMembersList.vue?vue&type=script&lang=js"
export * from "./ZgbTeamMembersList.vue?vue&type=script&lang=js"
import style0 from "./ZgbTeamMembersList.vue?vue&type=style&index=0&id=14bb64f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports